import flatpickr from 'flatpickr';
import { Instance } from 'flatpickr/dist/types/instance';
import { BaseOptions } from 'flatpickr/dist/types/options';

export class DatePickerController {
    // Looks like this datepicker has a required dep on jQuery
    public initialize = (querySelector: string, options?: Partial<BaseOptions>): Instance | Array<Instance> => {
        const defaultFormat: string = 'm/d/Y';
        if (!options) {
            options = {
                dateFormat: defaultFormat
            }
        } else {
            if (!options.dateFormat) {
                options.dateFormat = defaultFormat;
            }
        }
        return flatpickr(querySelector, options);
    }
}